// src/utils/themeClasses.ts
// Uses Tailwind primary-* and dark-* classes that are driven by the active theme preset.
export function getThemeClasses(isDarkMode: boolean) {
  return {
    bg: isDarkMode ? "bg-dark-bg" : "bg-white",
    border: isDarkMode ? "border-dark-border" : "border-gray-200",
    text: isDarkMode ? "text-white" : "text-gray-900",
    textSecondary: isDarkMode ? "text-gray-400" : "text-gray-500",
    cardBg: isDarkMode ? "bg-dark-surface" : "bg-white",
    cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
    buttonHover: isDarkMode ? "hover:bg-dark-surface" : "hover:bg-gray-50",
    buttonText: isDarkMode ? "text-gray-400" : "text-gray-500",
    buttonBg: "bg-primary-500",
    buttonHover2: "hover:bg-primary-400",
    buttonTextHover: isDarkMode ? "hover:text-white" : "hover:text-gray-900",
    inputBg: isDarkMode ? "bg-dark-surface" : "bg-gray-50",
    inputBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
    inputText: isDarkMode ? "text-white" : "text-gray-900",
    inputPlaceholder: "placeholder-gray-500",
    sidebarBg: isDarkMode ? "bg-dark-bg" : "bg-white",
  };
}
